export const COUNTRY_OPTIONS = [
  { code: 'CO', dial: '+57', label: '🇨🇴 Colombia (+57)' },
  { code: 'US', dial: '+1', label: '🇺🇸 Estados Unidos (+1)' },
  { code: 'MX', dial: '+52', label: '🇲🇽 México (+52)' },
  { code: 'ES', dial: '+34', label: '🇪🇸 España (+34)' },
];

export const DEFAULT_COUNTRY_DIAL = COUNTRY_OPTIONS[0].dial;
